import d2pImg from '~/images/icons/_filter-campaigns.svg';
import missingProjectPhotoImg from '~/images/completed-projects-map/missing-project-photo.png';
import t from '~/javascripts/utils/translation';
import wpsImg from '~/images/icons/ribbon.svg';
import { observer } from 'mobx-react';

const ProjectPhotos = observer(
  ({ isFirstProject, project, projectPhotoUrls }) => {
    const translationsIconClass = () => {
      try {
        return t(
          `d2p.project_types.${project.water_inventory_type}.icon_class`,
          {
            default: 'cw-icon-rehab',
          }
        );
      } catch {
        return 'cw-icon-rehab';
      }
    };

    return (
      <div className='photo-labels'>
        <div
          className='photo-grid flex justify-center items-center py-2 rounded border-solid border-grey-20 mx-2'
          style={{ height: '100px', borderWidth: '1px' }}
        >
          {projectPhotoUrls !== undefined && projectPhotoUrls.length == 0 && (
            <>
              <div className='photo-wd relative block'>
                <img loading='lazy' src={`${missingProjectPhotoImg}`} />
                <div className='swiper-lazy-preloader' style={{ top: '50%' }} />
              </div>
            </>
          )}
          {projectPhotoUrls !== undefined &&
            projectPhotoUrls.slice(0, 2).map((el, index) => (
              <>
                <div className='photo-wd relative w-1/2 flex'>
                  <img
                    loading='lazy'
                    src={`${projectPhotoUrls[index]}?fit=fill&w=168&height=100&auto=enhance,format`}
                  />
                  {!isFirstProject && (
                    <div
                      className='swiper-lazy-preloader'
                      style={{ top: '50%' }}
                    />
                  )}
                </div>
              </>
            ))}
        </div>
        <div className='labels flex items-start p-2'>
          <div className='label flex items-center text-xs mr-nudge rounded border border-solid border-grey-30 bg-cw-white'>
            <i className={`implementation icon ${translationsIconClass()}`} />
            <p className='font-normal'>{project.water_inventory_type}</p>
          </div>
          <div className='label flex items-center text-xs mr-nudge rounded border border-solid border-grey-30 bg-cw-white'>
            {project.project_category == 'd2p' && (
              <>
                <img height='22px' src={d2pImg} />
                <p>Funded by campaign(s)</p>
              </>
            )}
            {project.project_category == 'wps' && (
              <>
                <img height='13px' src={wpsImg} />
                <p>Funded by WPS</p>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
);
export default ProjectPhotos;
